import { F } from 'ramda';
import { assign } from 'xstate';
import { AppBarEvent } from '../../../events';
import { AppBarMachineContext } from '../../../machineContext';

export const name = 'setCollapse';

export const fn = assign<AppBarMachineContext, AppBarEvent>({
  collapse: () => 1,
  collapsingAction: () => 1,
  immediate: F,
});

export const action = {
  [name]: fn,
};

export default action;
